import { render } from "./InstaGram.vue?vue&type=template&id=fca9e896"
import script from "./InstaGram.vue?vue&type=script&lang=js"
export * from "./InstaGram.vue?vue&type=script&lang=js"

import "./InstaGram.vue?vue&type=style&index=0&id=fca9e896&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__